import PropTypes from "prop-types";
import React, { Component } from "react";
import dynamics from "dynamics.js";
import reactCSS from "reactcss";

const styles = reactCSS({
  default: {
    container: {
      textAlign: "center",
      display: "flex",
      justifyContent: "center",
      flexWrap: "wrap",
    },
    dot: {
      float: "left",
      margin: "0 5px",
      width: "12px",
      height: "12px",
      borderRadius: "12px",
      background: "#ccc",
    },
    text: {
      clear: "both",
      fontSize: ".8rem",
      color: "#1FA7DB",
      paddingTop: "1rem",
      width: "100%",
    },
  },
});

class Indicator extends Component {
  static propTypes = {
    text: PropTypes.string,
  };

  static defaultProps = {
    text: "",
  };

  componentDidMount() {
    this.animateDots();
    // this.animateText();
  }

  animateDots = () => {
    const {
      container,
    } = this.refs;

    if (!container) {
      return null;
    }

    const dots = container.querySelectorAll(
      ".indicator__dot",
    );

    for (let i = 0; i < dots.length; i++) {
      dynamics.animate(dots[i], {
        translateY: -40,
        backgroundColor: "#25aae1",
      }, {
        type: dynamics.forceWithGravity,
        bounciness: 800,
        elasticity: 200,
        duration: 2000,
        delay: i * 450,
      });
    }

    return dynamics.setTimeout(this.animateDots, 2500);
  };

  animateText = () => {
    const {
      text,
    } = this.refs;

    if (!text) {
      return null;
    }

    dynamics.css(text, {
      opacity: 1,
    });

    dynamics.animate(text, {
      opacity: 0,
    }, {
      type: dynamics.bounce,
      duration: 2000,
    });

    return dynamics.setTimeout(this.animateText, 2500);
  };

  render() {
    const {
      text,
    } = this.props;

    return (
      <div
        className="indicator"
        ref="container"
        style={styles.container}
      >
        <div>
          {
            [1, 2, 3].map((i) => (
              <span
                key={`dot-${i}`}
                className="indicator__dot chromatic-ignore"
                style={styles.dot}
              />
            ))
          }
        </div>
        <div style={styles.text}>
          {text
            && (
            <span
              ref="text"
            >
              {text}
            </span>
            )}
        </div>
      </div>
    );
  }
}

export default Indicator;
